import type { MenuItem, NavData } from './header';

export const headerData: MenuItem[] = [
  {
    text: 'Drivers Ed',
    href: '/drivers-ed/',
    position: 'top',
    isCurrentItem: false,
  },
  {
    text: 'Teens',
    href: '/teen-drivers-ed/',
    position: 'bottom',
    isCurrentItem: false,
  },
  {
    text: 'Adults',
    href: '/adult-drivers-ed/',
    position: 'bottom',
    isCurrentItem: false,
  },
  {
    text: 'In-Car Driving Lessons',
    href: '/driving-lessons/',
    position: 'top',
    isCurrentItem: false,
  },
  {
    text: 'Traffic School',
    href: '/traffic-school/',
    position: 'top',
    isCurrentItem: false,
  },
  {
    text: 'Permit Test Prep',
    href: '/permit-test-prep-courses/',
    position: 'top',
    isCurrentItem: false,
  },
  {
    text: 'DMV Information',
    href: '/dmv/',
    position: 'top',
    isCurrentItem: false,
  },
  {
    text: 'Blog',
    href: '/trending/',
    position: 'top',
    isCurrentItem: false,
  },
  {
    text: 'Community',
    href: null,
    position: 'top',
    isCurrentItem: false,
  },
  {
    text: 'Apps',
    href: '/apps/drivers-ed/',
    position: 'bottom',
    isCurrentItem: false,
  },
  {
    text: 'Partners',
    href: '/affiliates/',
    position: 'bottom',
    isCurrentItem: false,
  },
];
export const specificPageHeaderData: NavData = {
  'texas--adult-drivers-ed': {
    state: 'Texas',
    dmvLabel: 'DPS Information',
    reWriteDefault: true,
    menuItems: [
      {
        text: 'Drivers Ed',
        href: '/texas/drivers-ed/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Teens',
        href: '/texas/teen-drivers-ed/',
        position: 'bottom',
        isCurrentItem: false,
      },
      {
        text: 'Adults',
        href: '/texas/adult-drivers-ed/',
        position: 'bottom',
        isCurrentItem: false,
      },
      {
        text: 'In-Car Driving Lessons',
        href: '/texas/driving-lessons/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        isCurrentItem: false,
        href: '/texas/defensive-driving/',
        text: 'Defensive Driving',
        position: 'top',
        order: 4,
      },
      {
        isCurrentItem: false,
        href: '/texas/driving-record/',
        text: 'Driving Record',
        position: 'top',
        order: 5,
      },
      {
        text: 'Adult Final Exam Prep',
        href: '/permit-test-prep-courses/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'DPS Information',
        href: '/dmv/texas/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Blog',
        href: '/trending/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Community',
        href: null,
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Apps',
        href: '/apps/drivers-ed/',
        position: 'bottom',
        isCurrentItem: false,
      },
      {
        text: 'Partners',
        href: '/affiliates/',
        position: 'bottom',
        isCurrentItem: false,
      },
    ],
  },
};

export const newHeaderData: NavData = {
  default: { menuItems: headerData, state: 'Select State', dmvLabel: 'DMV Information' },
  alabama: {
    state: 'Alabama',
    dmvLabel: 'DPS Information',
    menuItems: [
      {
        isCurrentItem: false,
        href: 'https://www.idrivesafely.com/defensive-driving/alabama/',
        text: 'Defensive Driving School',
        position: 'top',
        order: 3,
      },
    ],
  },
  arizona: {
    state: 'Arizona',
    dmvLabel: 'MVD Information',
    menuItems: [
      {
        isCurrentItem: false,
        href: '/arizona/traffic-school/',
        text: 'Defensive Driving',
        position: 'top',
        order: 3,
      },
    ],
  },
  arkansas: { state: 'Arkansas', dmvLabel: 'ASP Information', menuItems: [] },
  california: {
    state: 'California',
    reWriteDefault: true,
    menuItems: [
      {
        text: 'Drivers Ed',
        href: '/california/drivers-ed/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Teens',
        href: '/california/teen-drivers-ed/',
        position: 'bottom',
        isCurrentItem: false,
      },
      {
        text: 'Adults',
        href: '/california/adult-drivers-ed/',
        position: 'bottom',
        isCurrentItem: false,
      },
      {
        text: 'In-Car Driving Lessons',
        href: '/california/driving-lessons/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Traffic School',
        href: '/california/traffic-school/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Knowledge Test Prep',
        href: '/permit-test-prep-courses/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'DMV Information',
        href: '/dmv/california/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Blog',
        href: '/trending/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Community',
        href: null,
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Apps',
        href: '/apps/drivers-ed/',
        position: 'bottom',
        isCurrentItem: false,
      },
      {
        text: 'Partners',
        href: '/affiliates/',
        position: 'bottom',
        isCurrentItem: false,
      },
    ],
  },
  colorado: {
    state: 'Colorado',
    dmvLabel: 'DMV Information',
    menuItems: [
      {
        isCurrentItem: false,
        href: '/colorado/driving-lessons/',
        text: 'In-Car Driving Lessons',
        position: 'top',
        order: 3,
      },
    ],
  },
  connecticut: {
    state: 'Connecticut',
    dmvLabel: 'DMV Information',
    menuItems: [],
  },
  delaware: {
    state: 'Delaware',
    dmvLabel: 'DMV Information',
    menuItems: [
      {
        isCurrentItem: false,
        href: '/delaware/traffic-school/',
        text: 'Traffic School',
        position: 'top',
        order: 3,
      },
    ],
  },
  idaho: {
    state: 'idaho',
    dmvLabel: 'DMV Information',
    menuItems: [],
  },
  florida: {
    state: 'Florida',
    reWriteDefault: true,
    menuItems: [
      {
        isCurrentItem: false,
        href: '/florida/learners-permit/',
        text: "Learner's Permit",
        position: 'top',
      },
      {
        isCurrentItem: false,
        href: '/florida/combo/',
        text: '15-17',
        position: 'bottom',
      },
      {
        isCurrentItem: false,
        href: '/florida/drug-and-alcohol/',
        text: '18+',
        position: 'bottom',
      },
      {
        isCurrentItem: false,
        href: '/florida/permit-test/',
        text: "Learner's Permit Test",
        position: 'top',
      },
      {
        text: 'Traffic School',
        href: '/traffic-school/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        isCurrentItem: false,
        href: '/permit-test-prep-courses/',
        text: 'Practice Permit Test',
        position: 'top',
      },
      {
        isCurrentItem: false,
        href: '/dmv/florida/',
        text: 'Driver & Vehicle Services',
        position: 'top',
      },
      {
        text: 'Blog',
        href: '/trending/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        isCurrentItem: false,
        href: null,
        text: 'Community',
        position: 'top',
      },
      {
        isCurrentItem: false,
        href: '/apps/drivers-ed/',
        text: 'Apps',
        position: 'bottom',
      },
      {
        isCurrentItem: false,
        href: '/affiliates/',
        text: 'Partners',
        position: 'bottom',
      },
    ],
  },
  georgia: {
    state: 'Georgia',
    dmvLabel: 'DDS Information',
    menuItems: [
      {
        isCurrentItem: false,
        href: '/georgia/driving-lessons/',
        text: 'In-Car Driving Lessons',
        position: 'top',
        order: 3,
      },
    ],
  },
  hawaii: { state: 'Hawaii', dmvLabel: 'DOT Information', menuItems: [] },
  illinois: {
    state: 'Illinois',
    dmvLabel: 'SOS Information',
    reWriteDefault: true,
    menuItems: [
      {
        text: 'Drivers Ed',
        href: '/illinois/adult-drivers-ed/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'In-Car Driving Lessons',
        href: '/illinois/driving-lessons/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Practice Permit Test',
        href: '/permit-test-prep-courses/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'SOS Information',
        href: '/dmv/illinois/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Blog',
        href: '/trending/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Community',
        href: null,
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Apps',
        href: '/apps/drivers-ed/',
        position: 'bottom',
        isCurrentItem: false,
      },
      {
        text: 'Partners',
        href: '/affiliates/',
        position: 'bottom',
        isCurrentItem: false,
      },
    ],
  },
  indiana: {
    state: 'Indiana',
    dmvLabel: 'BMV Information',
    menuItems: [
      {
        isCurrentItem: false,
        href: '/indiana/driving-lessons/',
        text: 'In-Car Driving Lessons',
        position: 'top',
        order: 3,
      },
    ],
  },
  iowa: { state: 'Iowa', dmvLabel: 'DOT Information', menuItems: [] },
  kansas: { state: 'Kansas', dmvLabel: 'DOR Information', menuItems: [] },
  kentucky: { state: 'Kentucky', dmvLabel: 'DDL Information', menuItems: [] },
  louisiana: {
    state: 'louisiana',
    dmvLabel: 'DMV Information',
    menuItems: [],
  },
  maine: { state: 'Maine', dmvLabel: 'BMV Information', menuItems: [] },
  maryland: { state: 'Maryland', dmvLabel: 'MVA Information', menuItems: [] },
  massachusetts: { state: 'Massachusetts', dmvLabel: 'RMV Information', menuItems: [] },
  michigan: {
    state: 'Michigan',
    dmvLabel: 'SOS Information',
    menuItems: [
      {
        isCurrentItem: false,
        href: '/michigan/traffic-school/',
        text: 'BDIC',
        position: 'top',
        order: 3,
      },
    ],
  },
  minnesota: {
    state: 'Minnesota',
    reWriteDefault: true,
    menuItems: [
      {
        text: 'Drivers Ed',
        href: '/minnesota/adult-drivers-ed/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Practice Permit Test',
        href: '/permit-test-prep-courses/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'DPS Information',
        href: '/dmv/minnesota/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Blog',
        href: '/trending/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Community',
        href: null,
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Apps',
        href: '/apps/drivers-ed/',
        position: 'bottom',
        isCurrentItem: false,
      },
      {
        text: 'Partners',
        href: '/affiliates/',
        position: 'bottom',
        isCurrentItem: false,
      },
    ],
  },
  mississippi: { state: 'Mississippi', dmvLabel: 'DPS Information', menuItems: [] },
  missouri: {
    state: 'Missouri',
    dmvLabel: 'DOR Information',
    menuItems: [
      {
        isCurrentItem: false,
        href: '/missouri/driving-lessons/',
        text: 'In-Car Driving Lessons',
        position: 'top',
        order: 3,
      },
    ],
  },
  montana: { state: 'Montana', dmvLabel: 'MVD Information', menuItems: [] },
  nebraska: {
    state: 'Nebraska',
    reWriteDefault: true,
    menuItems: [
      {
        text: 'Drivers Ed',
        href: '/nebraska/adult-drivers-ed/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Traffic School',
        href: 'https://www.idrivesafely.com/defensive-driving/nebraska/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Practice Permit Test',
        href: '/permit-test-prep-courses/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'DMV Information',
        href: '/dmv/nebraska/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Blog',
        href: '/trending/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Community',
        href: null,
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Apps',
        href: '/apps/drivers-ed/',
        position: 'bottom',
        isCurrentItem: false,
      },
      {
        text: 'Partners',
        href: '/affiliates/',
        position: 'bottom',
        isCurrentItem: false,
      },
    ],
  },
  nevada: {
    state: 'Nevada',
    dmvLabel: 'DMV Information',
    menuItems: [
      {
        isCurrentItem: false,
        href: '/nevada/driving-lessons/',
        text: 'In-Car Driving Lessons',
        position: 'top',
        order: 3,
      },
    ],
  },
  'new-hampshire': {
    state: 'new-hampshire',
    dmvLabel: 'DMV Information',
    menuItems: [],
  },
  'new-jersey': { state: 'New Jersey', dmvLabel: 'MVC Information', menuItems: [] },
  'new-mexico': {
    state: 'New Mexico',
    dmvLabel: 'DMV Information',
    reWriteDefault: true,
    menuItems: [
      {
        text: 'Defensive Driving',
        href: 'https://www.idrivesafely.com/defensive-driving/new-mexico/online/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Practice Permit Test',
        href: '/permit-test-prep-courses/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'DMV Information',
        href: '/dmv/new-mexico/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Blog',
        href: '/trending/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Community',
        href: null,
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Apps',
        href: '/apps/drivers-ed/',
        position: 'bottom',
        isCurrentItem: false,
      },
      {
        text: 'Partners',
        href: '/affiliates/',
        position: 'bottom',
        isCurrentItem: false,
      },
    ],
  },
  'new-york': {
    state: 'new-york',
    dmvLabel: 'DMV Information',
    menuItems: [],
  },
  'north-carolina': {
    state: 'North Carolina',
    reWriteDefault: true,
    menuItems: [
      {
        text: 'Drivers Ed',
        href: '/teen-drivers-ed/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Practice Permit Test',
        href: '/permit-test-prep-courses/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'DMV Information',
        href: '/dmv/north-carolina/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Blog',
        href: '/trending/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Community',
        href: null,
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Apps',
        href: '/apps/drivers-ed/',
        position: 'bottom',
        isCurrentItem: false,
      },
      {
        text: 'Partners',
        href: '/affiliates/',
        position: 'bottom',
        isCurrentItem: false,
      },
    ],
  },
  'north-dakota': { state: 'North Dakota', dmvLabel: 'DOT Information', menuItems: [] },
  ohio: {
    state: 'Ohio',
    dmvLabel: 'BMV Information',
    reWriteDefault: true,
    menuItems: [
      {
        text: 'Drivers Ed',
        href: '/ohio/drivers-ed/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Teens',
        href: '/ohio/teen-drivers-ed/',
        position: 'bottom',
        isCurrentItem: false,
      },
      {
        text: 'Adults',
        href: '/ohio/adult-drivers-ed/',
        position: 'bottom',
        isCurrentItem: false,
      },
      {
        text: 'Traffic School',
        href: 'https://www.idrivesafely.com/defensive-driving/ohio/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Knowledge Test Prep',
        href: '/permit-test-prep-courses/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'BMV Information',
        href: '/dmv/ohio/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Blog',
        href: '/trending/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Community',
        href: null,
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Apps',
        href: '/apps/drivers-ed/',
        position: 'bottom',
        isCurrentItem: false,
      },
      {
        text: 'Partners',
        href: '/affiliates/',
        position: 'bottom',
        isCurrentItem: false,
      },
    ],
  },
  oklahoma: { state: 'Oklahoma', dmvLabel: 'SOK Information', menuItems: [] },
  'south-dakota': { state: 'South Dakota', dmvLabel: 'DPS Information', menuItems: [] },
  oregon: {
    state: 'oregon',
    dmvLabel: 'DMV Information',
    menuItems: [],
  },
  pennsylvania: {
    state: 'Pennsylvania',
    dmvLabel: 'PennDOT Information',
    menuItems: [
      {
        text: 'Drivers Ed',
        href: '/pennsylvania/drivers-ed/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Teens',
        href: '/pennsylvania/teen-drivers-ed/',
        position: 'bottom',
        isCurrentItem: false,
      },
      {
        text: 'Adults',
        href: '/pennsylvania/adult-drivers-ed/',
        position: 'bottom',
        isCurrentItem: false,
      },
      {
        text: 'In-Car Driving Lessons',
        href: '/pennsylvania/driving-lessons/',
        position: 'top',
        isCurrentItem: false,
      },
    ],
  },
  'rhode-island': {
    state: 'rhode-island',
    dmvLabel: 'DMV Information',
    menuItems: [],
  },
  'south-carolina': {
    state: 'south-carolina',
    dmvLabel: 'DMV Information',
    menuItems: [],
  },
  tennessee: { state: 'Tennessee', dmvLabel: 'TDOS Information', menuItems: [] },
  texas: {
    state: 'Texas',
    dmvLabel: 'DPS Information',
    menuItems: [
      {
        isCurrentItem: false,
        href: '/texas/driving-lessons/',
        text: 'In-Car Driving Lessons',
        position: 'top',
        order: 3,
      },
      {
        isCurrentItem: false,
        href: '/texas/defensive-driving/',
        text: 'Defensive Driving',
        position: 'top',
        order: 4,
      },
      {
        isCurrentItem: false,
        href: '/texas/driving-record/',
        text: 'Driving Record',
        position: 'top',
        order: 5,
      },
    ],
  },
  utah: {
    state: 'Utah',
    dmvLabel: 'DPS Information',
    reWriteDefault: true,
    menuItems: [
      {
        text: 'Drivers Ed',
        href: '/utah/adult-drivers-ed/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Practice Permit Test',
        href: '/permit-test-prep-courses/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'DMV Information',
        href: '/dmv/utah/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Blog',
        href: '/trending/',
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Community',
        href: null,
        position: 'top',
        isCurrentItem: false,
      },
      {
        text: 'Apps',
        href: '/apps/drivers-ed/',
        position: 'bottom',
        isCurrentItem: false,
      },
      {
        text: 'Partners',
        href: '/affiliates/',
        position: 'bottom',
        isCurrentItem: false,
      },
    ],
  },
  vermont: {
    state: 'vermont',
    dmvLabel: 'DMV Information',
    menuItems: [],
  },
  virginia: {
    state: 'virginia',
    dmvLabel: 'DMV Information',
    menuItems: [],
  },
  'washington-dc': {
    state: 'washington-dc',
    dmvLabel: 'DMV Information',
    menuItems: [],
  },
  'west-virginia': { state: 'West Virginia', dmvLabel: 'DOT Information', menuItems: [] },
  wisconsin: {
    state: 'wisconsin',
    dmvLabel: 'DMV Information',
    menuItems: [],
  },
  wyoming: { state: 'Wyoming', dmvLabel: 'DOT Information', menuItems: [] },
};

export enum MenuGroup {
  DriversEd = 'Drivers Ed',
  Teens = 'Teens',
  Adults = 'Adults',
  PracticePermitTest = 'Practice Permit Test',
  DMVInformation = 'DMV Information',
}
